import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationResponse, Notification, ProfileInfo } from 'src/app/models';
import { NotificationService, ObservableService, ToastService, ProfileService } from 'src/app/services';
import { Router } from '@angular/router';


@Component({
    selector: 'app-notifications-modal',
    templateUrl: './notifications-modal.component.html',
    styleUrls: ['./notifications-modal.component.scss'],
    standalone: false
})
export class NotificationsModalComponent implements OnInit {

  @Input() data: NotificationResponse;
  recent: Notification[];
  older: Notification[];
  user: ProfileInfo;

  constructor(
    public activeModal: NgbActiveModal,
    private notificationService: NotificationService,
    private observableService: ObservableService,
    private toastService: ToastService,
    private profileService: ProfileService,
    private rotuer: Router,
  ) { }

  async ngOnInit() {
    this.recent = this.data.notification_item_recent;
    // console.log(this.recent)
    this.older = this.data.notification_item_older;
    try {

      // console.log('Notification modal')
      this.user = await this.profileService.getProfileInfo('');
    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  /**
   * Sets all notifications as read and plays an observable
   */

  async markAllNotificationAsRead() {
    try {
      const res = await this.notificationService.setAllNotificationAsRead();
      if (res.status) {
        this.observableService.updateNotificationData();
        // Recent notification are those of the last 24 hours
        if (this.recent.length > 0) {
          this.recent.forEach(notification => {
            notification.already_read = true;
          });
        }
        // Older notification are those after 24 hours
        if (this.older.length > 0) {
          this.older.forEach(notification => {
            notification.already_read = true;
          });
        }
      }
    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  /**
   * Redirect to the user's notification settings
   */

  goToProfileNotifications() {
    this.rotuer.navigate([`/profile/${this.user.id}/notification`]);
    this.activeModal.close();
  }
}
